import React, { useState, useEffect } from 'react';
import { Icon, Button, Modal, Form, Dropdown, Input, Label, Message } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import { post } from '../util/api';

const styles = {
	templateForm: { padding: '20px' },
	formRow: { display: 'flex', gap: '20px', marginBottom: '20px' },
	messageBlocks: { margin: '20px 0' },
	blockButtons: { display: 'flex', gap: '10px', marginTop: '10px' },
	sectionHeader: { display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' },
	formattingButtons: { display: 'flex', gap: '5px', marginTop: '5px' },
	charCounter: { textAlign: 'right', color: '#666', fontSize: '12px', marginTop: '5px' },
	buttonCounter: { textAlign: 'right', color: '#666', fontSize: '12px', marginTop: '10px' },
	buttonField: { marginBottom: '15px', padding: '10px', border: '1px solid #ddd', borderRadius: '4px' },
	contentWrapper: { display: 'flex' },
	formWrapper: { flex: 2, marginRight: '20px' },
	previewWrapper: { flex: 1 },
	previewContainer: {
		border: '1px solid #e0e0e0',
		borderRadius: '8px',
		padding: '15px',
		marginTop: '10px',
		boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
		wordWrap: 'break-word',
		overflowWrap: 'break-word',
		background: '#e5ddd5',
	},
	previewSection: {
		marginBottom: '15px',
		paddingTop: '2px',
	},
	previewHeader: {
		fontWeight: 'bold',
		color: '#075E54',
		marginBottom: '8px',
		wordBreak: 'break-word',
	},
	previewText: {
		whiteSpace: 'pre-wrap',
		wordBreak: 'break-word',
		overflowWrap: 'break-word',
	},
	previewMediaWrapper: {
		width: '100%',
		borderRadius: '8px',
		overflow: 'hidden',
		marginBottom: '10px',
		background: '#fff',
	},
	mediaPreview: {
		width: '100%',
		maxHeight: '200px',
		objectFit: 'contain',
		borderRadius: '8px',
		display: 'block',
	},
	mediaPlaceholder: {
		width: '100%',
		height: '93px',
		background: '#fff',
		border: '1px solid #D3DCE6',
		borderRadius: '8px',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		marginBottom: '10px',
	},
	previewMedia: {
		background: '#f0f0f0',
		padding: '20px',
		textAlign: 'center',
		borderRadius: '8px',
		marginBottom: '10px',
		color: '#666',
	},
	variablePreview: {
		padding: '8px 12px',
		borderRadius: '7px',
		marginBottom: '8px',
		position: 'relative',
		whiteSpace: 'pre-wrap',
		wordBreak: 'break-word',
		fontSize: '14px',
		lineHeight: '1.4',
	},
	previewFooter: {
		color: '#666',
		fontSize: '12px',
		marginTop: '8px',
		wordBreak: 'break-word',
	},
	previewButtons: {
		marginTop: '15px',
		display: 'flex',
		flexDirection: 'column',
		gap: '8px',
	},
	previewButton: {
		background: '#25D366',
		color: 'white',
		padding: '8px 12px',
		borderRadius: '4px',
		textAlign: 'center',
		cursor: 'pointer',
		wordBreak: 'break-word',
		whiteSpace: 'pre-wrap',
		fontSize: '14px',
		fontWeight: '500',
	},
};
const defaultState = {
	name: '',
	type: 'MEDIA',
	language: 'en',
	category: 'MARKETING',
	allowCategoryChange: 'NO',
	components: {
		header: { enabled: false, type: 'TEXT', text: '', format: 'TEXT' },
		body: { enabled: true, text: '' },
		footer: { enabled: false, text: '' },
		buttons: [], // Her buton için: { type: '', text: '', value: '' }
		variables: {},
	},
};

function WhatsAppTemplates({ modalOpen, onClose, onTemplateCreated, template, t, phoneNumber }) {
	const [isEditing, setIsEditing] = useState(false);
	const [templateType, setTemplateType] = useState('MEDIA');
	const [templateData, setTemplateData] = useState(defaultState);
	const [step, setStep] = useState(1); // Added for two-step process
	const [buttonLoading, setButtonLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	useEffect(() => {
		if (template) {
			setIsEditing(true);
			const formattedTemplate = formatTemplateForEditing(template);
			setTemplateData(formattedTemplate);
			setTemplateType(formattedTemplate.type);
		} else {
			setIsEditing(false);
			setTemplateData(defaultState);
			setTemplateType('MEDIA');
		}
	}, [template]);
	// Helper function to format template data for editing
	function formatTemplateForEditing(template) {
		const formattedTemplate = {
			name: template.name,
			type: template.type || 'MEDIA',
			language: template.language || 'en',
			category: template.category || 'MARKETING',
			allowCategoryChange: template.allowCategoryChange || 'NO',
			components: {
				header: { enabled: false, type: 'TEXT', text: '', format: 'TEXT' },
				body: { enabled: true, text: '' },
				footer: { enabled: false, text: '' },
				buttons: [],
				variables: {},
			},
		};

		// Format components
		if (template.components) {
			template.components.forEach((comp) => {
				switch (comp.type) {
					case 'HEADER':
						formattedTemplate.components.header = {
							enabled: true,
							type: comp.format || 'TEXT',
							text: comp.text || '',
							format: comp.format || 'TEXT',
							url: comp.url || '',
						};
						break;
					case 'BODY':
						formattedTemplate.components.body = {
							enabled: true,
							text: comp.text || '',
						};
						break;
					case 'FOOTER':
						formattedTemplate.components.footer = {
							enabled: true,
							text: comp.text || '',
						};
						break;
					case 'BUTTONS':
						formattedTemplate.components.buttons = comp.buttons || [];
						break;
				}
			});
		}

		return formattedTemplate;
	}
	function handleBlockToggle(blockName) {
		setTemplateData(function (prev) {
			const newState = {
				...prev,
				components: {
					...prev.components,
				},
			};

			if (blockName === 'buttons') {
				// Eğer butonlar etkinleştiriliyorsa ve hiç buton yoksa, bir tane ekle
				if (newState.components.buttons.length === 0) {
					newState.components.buttons = [{ type: 'PHONE_NUMBER', text: '', value: '' }];
				} else {
					// Butonlar devre dışı bırakılıyorsa, diziyi temizle
					newState.components.buttons = [];
				}
			} else {
				// Diğer bileşenler için normal toggle işlemi
				newState.components[blockName] = {
					...prev.components[blockName],
					enabled: !prev.components[blockName].enabled,
				};
			}

			return newState;
		});
	}

	function handleHeaderTypeChange(_, data) {
		const value = data.value || 'TEXT';
		setTemplateData(function (prev) {
			return {
				...prev,
				components: {
					...prev.components,
					header: {
						...prev.components.header,
						type: value,
						format: value, // ← bunu ekle
						text: value === 'TEXT' ? prev.components.header.text : '',
						url: value !== 'TEXT' ? '' : undefined,
					},
				},
			};
		});
	}
	function handleHeaderUrlChange(e) {
		const value = e.target.value || '';
		setTemplateData(function (prev) {
			return {
				...prev,
				components: {
					...prev.components,
					header: {
						...prev.components.header,
						url: value,
					},
				},
			};
		});
	}
	// handleHeaderTextChange için düzeltme
	function handleHeaderTextChange(e) {
		const value = e.target.value || '';
		setTemplateData(function (prev) {
			const newState = {
				...prev,
				components: {
					...prev.components,
					header: {
						...prev.components.header,
						text: value,
					},
				},
			};
			return newState;
		});
	}

	function handleBodyTextChange(e) {
		const value = e.target.value || ''; // null check
		setTemplateData(function (prev) {
			return {
				...prev,
				components: {
					...prev.components,
					body: {
						...prev.components.body,
						text: value,
					},
				},
			};
		});
	}

	// Footer TextArea için düzeltme
	function handleFooterTextChange(e) {
		const value = e.target.value || '';
		setTemplateData(function (prev) {
			const newState = {
				...prev,
				components: {
					...prev.components,
					footer: {
						...prev.components.footer,
						text: value,
					},
				},
			};
			return newState;
		});
	}

	// handleAddButton güncellemesi
	function handleAddButton() {
		if (templateData.components.buttons.length < 10) {
			setTemplateData(function (prev) {
				return {
					...prev,
					components: {
						...prev.components,
						buttons: [
							...prev.components.buttons,
							{
								type: 'PHONE_NUMBER',
								text: '',
								value: '',
							},
						],
					},
				};
			});
		}
	}

	function handleButtonTypeChange(index, type) {
		setTemplateData(function (prev) {
			const newState = { ...prev };
			const newButtons = [...prev.components.buttons];
			newButtons[index] = {
				...newButtons[index],
				type: type,
				value: '', // Tip değiştiğinde value'yu sıfırla
			};
			newState.components = {
				...prev.components,
				buttons: newButtons,
			};
			return newState;
		});
	}

	// Button handlers
	function handleButtonTextChange(index, text) {
		setTemplateData(function (prev) {
			const newState = { ...prev };
			const newButtons = [...prev.components.buttons];
			newButtons[index] = { ...newButtons[index], text: text || '' };
			newState.components = {
				...prev.components,
				buttons: newButtons,
			};
			return newState;
		});
	}
	function handleButtonValueChange(index, value) {
		setTemplateData(function (prev) {
			const newState = { ...prev };
			const newButtons = [...prev.components.buttons];
			newButtons[index] = { ...newButtons[index], value: value || '' };
			newState.components = {
				...prev.components,
				buttons: newButtons,
			};
			return newState;
		});
	}
	// handleTemplateSubmit fonksiyonunu güncelleyelim

	async function handleTemplateSubmit() {
		setButtonLoading(true);
		setErrorMessage(''); // Her submit'te hata mesajını temizle
		try {
			const endpoint = isEditing ? `/messenger/waba/message_template/update/${phoneNumber}` : `/messenger/waba/message_template/create/${phoneNumber}`;

			const response = await post(endpoint, {
				template: templateData,
				templateId: isEditing ? template.id : undefined,
			});
			if (response && response.data && response.data.success) {
				onTemplateCreated(true);
				setStep(1);
				setTemplateData(defaultState);
				onClose();
			} else {
				console.error('Error submitting template:', response);
				setErrorMessage(response?.message || 'An error occurred while submitting template');
			}
		} catch (error) {
			console.error('Error submitting template:', error);
			setErrorMessage(error?.message || 'An error occurred while submitting template');
		} finally {
			setButtonLoading(false);
		}
	}

	function handleAddVariable() {
		const currentText = templateData.components.body.text;
		const variableCount = (currentText.match(/{{[0-9]+}}/g) || []).length;
		const newVariable = `{{${variableCount + 1}}}`;

		setTemplateData((prev) => ({
			...prev,
			components: {
				...prev.components,
				body: {
					...prev.components.body,
					text: currentText + newVariable,
				},
			},
		}));
	}

	// Add function to handle variable value changes
	function handleVariableValueChange(variable, value) {
		setTemplateData((prev) => ({
			...prev,
			components: {
				...prev.components,
				variables: {
					...prev.components.variables,
					[variable]: value,
				},
			},
		}));
	}
	function getHeaderTypeIcon(type) {
		switch (type) {
			case 'IMAGE':
				return 'image';
			case 'VIDEO':
				return 'video';
			case 'DOCUMENT':
				return 'file';
			default:
				return 'file text';
		}
	}
	function renderVariableInputs() {
		const variables = (templateData.components.body.text.match(/{{[0-9]+}}/g) || []).map((v) => v.replace(/[{}]/g, ''));

		return (
			<div style={styles.variableInputs}>
				{templateData.components.header.enabled && templateData.components.header.type !== 'TEXT' && (
					<div style={styles.variableField}>
						<div style={styles.variableLabel}>{templateData.components.header.type} URL</div>
						<Form.Input
							placeholder={`Enter ${templateData.components.header.type.toLowerCase()} URL...`}
							value={templateData.components.header.url || ''}
							onChange={handleHeaderUrlChange}
						/>
					</div>
				)}

				<h3>Example Values</h3>
				{variables.map((variable) => (
					<div key={variable} style={styles.variableField}>
						<div style={styles.variableLabel}>Variable {variable}</div>
						<Form.Input
							placeholder={`Enter example value for {{${variable}}}`}
							value={templateData.components.variables[variable] || ''}
							onChange={(e) => handleVariableValueChange(variable, e.target.value)}
						/>
					</div>
				))}
			</div>
		);
	}
	// Modified renderPreview to show variables
	function renderPreview() {
		return (
			<div id="preview" style={styles.previewContainer}>
				<div id="messageBar2">
					{templateData.components.header.enabled && (
						<div style={styles.previewSection}>
							{templateData.components.header.type === 'TEXT' ? (
								<div style={{ ...styles.previewHeader, ...styles.previewText }}>
									{replaceVariables(templateData.components.header.text) || t('headerText')}
								</div>
							) : step === 2 && templateData.components.header.url ? (
								<>
									{templateData.components.header.type === 'IMAGE' && (
										<div style={styles.previewMediaWrapper}>
											<img
												src={templateData.components.header.url}
												alt="Header"
												style={styles.mediaPreview}
												onError={(e) => {
													e.target.onerror = null;
													e.target.src = '/placeholder-image.png';
												}}
											/>
										</div>
									)}
									{templateData.components.header.type === 'VIDEO' && (
										<div style={styles.previewMediaWrapper}>
											<video src={templateData.components.header.url} controls style={styles.mediaPreview}>
												Your browser does not support the video tag.
											</video>
										</div>
									)}
									{templateData.components.header.type === 'DOCUMENT' && (
										<div style={styles.previewMedia}>
											<Icon name="file" size="big" />
											<div>[DOCUMENT Content]</div>
										</div>
									)}
								</>
							) : (
								<div style={styles.mediaPlaceholder}>
									<svg width="357" height="93" viewBox="0 0 357 93" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M1 97.5L102.261 31.6607L171.443 76.6054M135.5 104L245.75 18L356 104" stroke="#D3DCE6" stroke-width="2" />
										<circle cx="61.5" cy="9.5" r="8.5" stroke="#D3DCE6" stroke-width="2" />
									</svg>
								</div>
							)}
						</div>
					)}

					<div
						style={{
							...styles.variablePreview,
							borderRadius: '7px',
							position: 'relative',
							marginBottom: '8px',
							whiteSpace: 'pre-wrap',
							wordBreak: 'break-word',
						}}
					>
						{replaceVariables(templateData.components.body.text) || t('prewiewMessage')}
					</div>

					{templateData.components.footer.enabled && templateData.components.footer.text && (
						<div style={{ ...styles.previewFooter, ...styles.previewText }}>{replaceVariables(templateData.components.footer.text)}</div>
					)}

					{templateData.components.buttons.length > 0 && (
						<div style={styles.previewButtons}>
							{templateData.components.buttons.map((button, index) => (
								<div
									key={index}
									style={{
										...styles.previewButton,
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										gap: '8px',
									}}
								>
									{button.type === 'PHONE_NUMBER' && <Icon name="phone" />}
									{button.type === 'URL' && <Icon name="linkify" />}
									{button.type === 'QUICK_REPLY' && <Icon name="reply" />}
									{button.text || `Button ${index + 1}`}
								</div>
							))}
						</div>
					)}
				</div>
			</div>
		);
	}
	function renderTemplateForm() {
		if (step === 2) {
			return (
				<div
					style={{
						display: 'flex',
						gap: '40px',
						height: '100%',
					}}
				>
					{/* Sol Kolon - Input Alanları */}
					<div
						style={{
							flex: '0 0 40%',
							overflowY: 'auto',
						}}
					>
						<Form>
							{templateData.components.header.enabled && templateData.components.header.type !== 'TEXT' && (
								<Form.Field>
									<div style={styles.sectionHeader}>
										<Label color="grey">{templateData.components.header.type} URL</Label>
									</div>
									<Form.Input
										placeholder={`Enter ${templateData.components.header.type.toLowerCase()} URL...`}
										value={templateData.components.header.url || ''}
										onChange={handleHeaderUrlChange}
									/>
								</Form.Field>
							)}

							<Form.Field>
								<div style={styles.sectionHeader}>
									<Label color="grey">EXAMPLE VALUES</Label>
								</div>
								{(templateData.components.body.text.match(/{{[0-9]+}}/g) || [])
									.map((v) => v.replace(/[{}]/g, ''))
									.map((variable) => (
										<div key={variable} style={{ marginBottom: '15px' }}>
											<Form.Input
												label={`Variable ${variable}`}
												placeholder={`Enter example value for {{${variable}}}`}
												value={templateData.components.variables[variable] || ''}
												onChange={(e) => handleVariableValueChange(variable, e.target.value)}
											/>
										</div>
									))}
							</Form.Field>
						</Form>
					</div>

					{/* Sağ Kolon - Preview */}
					<div
						style={{
							flex: '0 0 50%',
							overflowY: 'auto',
						}}
					>
						<h3>Preview</h3>
						{renderPreview()}
					</div>
				</div>
			);
		}
		return (
			<div style={styles.templateForm}>
				<Form>
					<Form.Field>
						<label>{t('templateName')}</label>
						<Input
							placeholder={t('enterTemplateName')}
							value={templateData.name}
							onChange={function (e) {
								setTemplateData(Object.assign({}, templateData, { name: e.target.value }));
							}}
						/>
					</Form.Field>

					<div style={styles.formRow}>
						<Form.Field width={8}>
							<label>{t('category')}</label>
							<Dropdown
								selection
								value={templateData.category}
								options={[
									{ key: 'authentication', text: t('authentication'), value: 'AUTHENTICATION' },
									{ key: 'marketing', text: t('marketing'), value: 'MARKETING' },
									{ key: 'utility', text: t('utility'), value: 'UTILITY' },
								]}
								onChange={function (_, { value }) {
									setTemplateData(Object.assign({}, templateData, { category: value }));
								}}
							/>
						</Form.Field>

						<Form.Field width={8}>
							<label>{t('allowCategoryChange')}</label>
							<Dropdown
								selection
								value={templateData.allowCategoryChange}
								options={[
									{ key: 'yes', text: t('allowCategoryYes'), value: 'YES' },
									{ key: 'no', text: t('allowCategoryNo'), value: 'NO' },
								]}
								onChange={function (_, { value }) {
									setTemplateData(
										Object.assign({}, templateData, {
											allowCategoryChange: value,
										})
									);
								}}
							/>
						</Form.Field>
					</div>

					<div style={styles.formRow}>
						<Form.Field width={8}>
							<label>{t('templateType')}</label>
							<Dropdown
								selection
								value={templateData.type}
								options={[
									{ key: 'media', text: t('templateTypeMedia'), value: 'MEDIA' },
									{ key: 'text', text: t('templateTypeText'), value: 'TEXT' },
								]}
								onChange={function (_, { value }) {
									setTemplateType(value);
									setTemplateData(function (prev) {
										var newState = Object.assign({}, prev);
										newState.type = value;
										newState.components.header.enabled = value === 'MEDIA';
										newState.components.footer.enabled = value === 'MEDIA';
										newState.components.buttons = value === 'MEDIA' ? prev.components.buttons : [];
										return newState;
									});
								}}
							/>
						</Form.Field>

						<Form.Field width={8}>
							<label>{t('language')}</label>
							<Dropdown
								selection
								value={templateData.language}
								search={true}
								options={[
									{ key: 'af', text: 'Afrikaans (af)', value: 'af' },
									{ key: 'sq', text: 'Albanian (sq)', value: 'sq' },
									{ key: 'ar', text: 'Arabic (ar)', value: 'ar' },
									{ key: 'az', text: 'Azerbaijani (az)', value: 'az' },
									{ key: 'bn', text: 'Bengali (bn)', value: 'bn' },
									{ key: 'bg', text: 'Bulgarian (bg)', value: 'bg' },
									{ key: 'ca', text: 'Catalan (ca)', value: 'ca' },
									{ key: 'zh_CN', text: 'Chinese (CHN)', value: 'zh_CN' },
									{ key: 'zh_HK', text: 'Chinese (HKG)', value: 'zh_HK' },
									{ key: 'zh_TW', text: 'Chinese (TAI)', value: 'zh_TW' },
									{ key: 'hr', text: 'Croatian (hr)', value: 'hr' },
									{ key: 'cs', text: 'Czech (cs)', value: 'cs' },
									{ key: 'da', text: 'Danish (da)', value: 'da' },
									{ key: 'nl', text: 'Dutch (nl)', value: 'nl' },
									{ key: 'en', text: 'English (en)', value: 'en' },
									{ key: 'en_GB', text: 'English (UK)', value: 'en_GB' },
									{ key: 'en_US', text: 'English (US)', value: 'en_US' },
									{ key: 'et', text: 'Estonian (et)', value: 'et' },
									{ key: 'fil', text: 'Filipino (fil)', value: 'fil' },
									{ key: 'fi', text: 'Finnish (fi)', value: 'fi' },
									{ key: 'fr', text: 'French (fr)', value: 'fr' },
									{ key: 'ka', text: 'Georgian (ka)', value: 'ka' },
									{ key: 'de', text: 'German (de)', value: 'de' },
									{ key: 'el', text: 'Greek (el)', value: 'el' },
									{ key: 'gu', text: 'Gujarati (gu)', value: 'gu' },
									{ key: 'ha', text: 'Hausa (ha)', value: 'ha' },
									{ key: 'he', text: 'Hebrew (he)', value: 'he' },
									{ key: 'hi', text: 'Hindi (hi)', value: 'hi' },
									{ key: 'hu', text: 'Hungarian (hu)', value: 'hu' },
									{ key: 'id', text: 'Indonesian (id)', value: 'id' },
									{ key: 'ga', text: 'Irish (ga)', value: 'ga' },
									{ key: 'it', text: 'Italian (it)', value: 'it' },
									{ key: 'ja', text: 'Japanese (ja)', value: 'ja' },
									{ key: 'kn', text: 'Kannada (kn)', value: 'kn' },
									{ key: 'kk', text: 'Kazakh (kk)', value: 'kk' },
									{ key: 'rw_RW', text: 'Kinyarwanda (rw_RW)', value: 'rw_RW' },
									{ key: 'ko', text: 'Korean (ko)', value: 'ko' },
									{ key: 'ky_KG', text: 'Kyrgyz (ky_KG)', value: 'ky_KG' },
									{ key: 'lo', text: 'Lao (lo)', value: 'lo' },
									{ key: 'lv', text: 'Latvian (lv)', value: 'lv' },
									{ key: 'lt', text: 'Lithuanian (lt)', value: 'lt' },
									{ key: 'mk', text: 'Macedonian (mk)', value: 'mk' },
									{ key: 'ms', text: 'Malay (ms)', value: 'ms' },
									{ key: 'ml', text: 'Malayalam (ml)', value: 'ml' },
									{ key: 'mr', text: 'Marathi (mr)', value: 'mr' },
									{ key: 'nb', text: 'Norwegian (nb)', value: 'nb' },
									{ key: 'fa', text: 'Persian (fa)', value: 'fa' },
									{ key: 'pl', text: 'Polish (pl)', value: 'pl' },
									{ key: 'pt_BR', text: 'Portuguese (BR)', value: 'pt_BR' },
									{ key: 'pt_PT', text: 'Portuguese (POR)', value: 'pt_PT' },
									{ key: 'pa', text: 'Punjabi (pa)', value: 'pa' },
									{ key: 'ro', text: 'Romanian (ro)', value: 'ro' },
									{ key: 'ru', text: 'Russian (ru)', value: 'ru' },
									{ key: 'sr', text: 'Serbian (sr)', value: 'sr' },
									{ key: 'sk', text: 'Slovak (sk)', value: 'sk' },
									{ key: 'sl', text: 'Slovenian (sl)', value: 'sl' },
									{ key: 'es', text: 'Spanish (es)', value: 'es' },
									{ key: 'es_AR', text: 'Spanish (ARG)', value: 'es_AR' },
									{ key: 'es_ES', text: 'Spanish (SPA)', value: 'es_ES' },
									{ key: 'es_MX', text: 'Spanish (MEX)', value: 'es_MX' },
									{ key: 'sw', text: 'Swahili (sw)', value: 'sw' },
									{ key: 'sv', text: 'Swedish (sv)', value: 'sv' },
									{ key: 'ta', text: 'Tamil (ta)', value: 'ta' },
									{ key: 'te', text: 'Telugu (te)', value: 'te' },
									{ key: 'th', text: 'Thai (th)', value: 'th' },
									{ key: 'tr', text: 'Turkish (tr)', value: 'tr' },
									{ key: 'uk', text: 'Ukrainian (uk)', value: 'uk' },
									{ key: 'ur', text: 'Urdu (ur)', value: 'ur' },
									{ key: 'uz', text: 'Uzbek (uz)', value: 'uz' },
									{ key: 'vi', text: 'Vietnamese (vi)', value: 'vi' },
									{ key: 'zu', text: 'Zulu (zu)', value: 'zu' },
								]}
								onChange={function (_, { value }) {
									setTemplateData(Object.assign({}, templateData, { language: value }));
								}}
							/>
						</Form.Field>
					</div>
					{templateType === 'MEDIA' && (
						<div style={styles.messageBlocks}>
							<label>{t('selectTemplateBlocks')}</label>
							<div style={styles.blockButtons}>
								<Button
									color={templateData.components.header.enabled ? 'teal' : undefined}
									onClick={function () {
										handleBlockToggle('header');
									}}
								>
									<Icon name="check" />
									Header
								</Button>
								<Button
									color="teal"
									onClick={function () {
										handleBlockToggle('body');
									}}
								>
									<Icon name="check" />
									Body
								</Button>
								<Button
									color={templateData.components.footer.enabled ? 'teal' : undefined}
									onClick={function () {
										handleBlockToggle('footer');
									}}
								>
									<Icon name="check" />
									Footer
								</Button>
								<Button
									color={templateData.components.buttons.length > 0 ? 'teal' : undefined}
									onClick={function () {
										handleBlockToggle('buttons');
									}}
								>
									<Icon name="check" />
									Buttons
								</Button>
							</div>
						</div>
					)}

					{templateData.components.header.enabled && (
						<Form.Field>
							<div style={styles.sectionHeader}>
								<Label color="grey">HEADER</Label>
								<Dropdown
									selection
									value={templateData.components.header.type}
									options={[
										{ key: 'text', text: 'Text', value: 'TEXT' },
										{ key: 'image', text: 'Image', value: 'IMAGE' },
										{ key: 'video', text: 'Video', value: 'VIDEO' },
										{ key: 'document', text: 'Document', value: 'DOCUMENT' },
									]}
									onChange={handleHeaderTypeChange}
								/>
							</div>
							{templateData.components.header.type === 'TEXT' && (
								<>
									<Form.TextArea
										placeholder={t('typeHeaderText')}
										value={templateData.components.header.text}
										onChange={handleHeaderTextChange}
									/>
									<div style={styles.charCounter}>
										{(templateData.components.header.text || '').length}/60 {t('characters')}
									</div>
								</>
							)}
						</Form.Field>
					)}

					<Form.Field>
						<div style={styles.sectionHeader}>
							<Label color="grey">BODY</Label>
						</div>
						<Form.TextArea placeholder={t('typeBodyText')} value={templateData.components.body.text} onChange={handleBodyTextChange} />
						<div style={styles.formattingButtons}>
							{/* <Button icon="smile outline" />
							<Button icon="bold" />
							<Button icon="italic" /> */}
							<Button content={t('addVariable')} onClick={handleAddVariable} />
						</div>
					</Form.Field>
					{templateData.components.footer.enabled && (
						<Form.Field>
							<div style={styles.sectionHeader}>
								<Label color="grey">FOOTER</Label>
							</div>
							<Form.TextArea
								placeholder={t('typeFooterText')}
								value={templateData.components.footer.text || ''}
								onChange={handleFooterTextChange}
							/>
							<div style={styles.charCounter}>
								{(templateData.components.footer.text || '').length}/60 {t('characters')}
							</div>
						</Form.Field>
					)}

					{templateData.components.buttons.length > 0 && (
						<Form.Field>
							<div style={styles.sectionHeader}>
								<Label color="grey">BUTTONS</Label>
								<Button icon="add" content={t('addButton')} onClick={handleAddButton} />
							</div>
							{templateData.components.buttons.map(function (button, index) {
								return (
									<div key={index} style={styles.buttonField}>
										<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
											<Label color="grey">BUTTON</Label>
											<Button
												icon="trash"
												size="tiny"
												onClick={function () {
													setTemplateData(function (prev) {
														const newButtons = prev.components.buttons.filter((_, i) => i !== index);
														return {
															...prev,
															components: {
																...prev.components,
																buttons: newButtons,
															},
														};
													});
												}}
											/>
										</div>
										<div style={{ marginBottom: '10px' }}>
											<Dropdown
												selection
												fluid
												value={button.type}
												options={[
													{ key: 'phone', text: 'Phone number', value: 'PHONE_NUMBER' },
													{ key: 'url', text: 'URL', value: 'URL' },
													{ key: 'quick_reply', text: 'Quick reply', value: 'QUICK_REPLY' },
												]}
												onChange={function (_, { value }) {
													handleButtonTypeChange(index, value);
												}}
											/>
										</div>
										<div style={{ marginBottom: '10px' }}>
											<Form.Input
												placeholder="Button title..."
												value={button.text || ''}
												onChange={function (e) {
													handleButtonTextChange(index, e.target.value);
												}}
											/>
											<div style={styles.charCounter}>
												{(button.text || '').length}/25 {t('characters')}
											</div>
										</div>
										{(button.type === 'PHONE_NUMBER' || button.type === 'URL') && (
											<div>
												<Form.Input
													placeholder={button.type === 'PHONE_NUMBER' ? t('enterPhoneNumber') : t('enterUrl')}
													value={button.value || ''}
													onChange={function (e) {
														handleButtonValueChange(index, e.target.value);
													}}
												/>
											</div>
										)}
									</div>
								);
							})}
							<div style={styles.buttonCounter}>
								{templateData.components.buttons.length}/10 {t('buttons_count')}
							</div>
						</Form.Field>
					)}
				</Form>
			</div>
		);
	}
	function replaceVariables(text) {
		if (!text) return '';
		return text.replace(/{{(\d+)}}/g, (match, number) => {
			const value = templateData.components.variables[number];
			return value || match;
		});
	}
	return (
		<Modal open={modalOpen} onClose={onClose} size="large">
			<Modal.Header>{isEditing ? t('editTemplate') : step === 1 ? t('newTemplate') : t('previewAndExamples')}</Modal.Header>
			<Modal.Content>
				{errorMessage && (
					<Message negative style={{ marginBottom: '1rem' }}>
						<Message.Header>Error</Message.Header>
						<p>{errorMessage}</p>
					</Message>
				)}
				{step === 1 ? (
					<div style={styles.contentWrapper}>
						<div style={styles.formWrapper}>{renderTemplateForm()}</div>
						<div style={styles.previewWrapper}>
							<h3>{t('preview')}</h3>
							{renderPreview()}
						</div>
					</div>
				) : (
					renderTemplateForm()
				)}
			</Modal.Content>
			<Modal.Actions>
				{step === 1 ? (
					<>
						<Button
							onClick={() => {
								setTemplateData(defaultState);
								onClose();
							}}
						>
							{t('discardChanges')}
						</Button>
						<Button
							primary
							onClick={() => {
								if (!templateData.components.body.text || !templateData.components.body.text.trim()) {
									setErrorMessage('Body text is required');
									return;
								}
								setStep(2);
							}}
						>
							{t('next')}
						</Button>
					</>
				) : (
					<>
						<Button onClick={() => setStep(1)}>{t('back')}</Button>
						<Button primary onClick={handleTemplateSubmit} loading={buttonLoading}>
							{isEditing ? t('updateTemplate') : t('submitTemplate')}
						</Button>
					</>
				)}
			</Modal.Actions>
		</Modal>
	);
}

export default connect()(withTranslation()(WhatsAppTemplates));
